/**
 * システム全体の設定
 */
const Setting = {
  'speed_unit': 'knot'
};

export default Setting;
